<template>
  <v-container class="representative pa-0">
    <v-card :color="'#FFFFFF'" flat rounded="0" class="pb-4">
      <v-card-title :class="$vuetify.display.xs ? 'pl-2 pr-2' : ''">
        <v-row align-content="center">
          <v-col
            cols="12"
            sm="6"
            :md="hide ? 12 : 6"
            :lg="hide ? 12 : 6"
            class="mx-0 pb-4 mt-4 pl-4 pr-4"
            :class="{ 'text-center': hide }"
          >
            <h1 class="text-wrap" :class="$vuetify.display.xs ? 'text-h3' : 'text-h2'">
              {{ title }}
            </h1>
          </v-col>
          <v-col
            class="px-0 pl-4 pr-4 mt-0"
            v-if="agents.length > 1 && !hide"
            align-self="center"
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <OnexSelect
              variant="filled"
              :label="$t('')"
              :items="agents"
              item-title="account"
              item-value="index"
              v-model="currentAgent"
              color="black"
              :menu-props="{ location: 'bottom center', scrollStrategy: 'close' }"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="hide" class="text-center">
          <v-col align-self="center">
            <p class="text-body-1 mt-2">{{ $t('L_call_the_home_office') }}</p>
            <p class="text-body-1 mt-2">
              <v-icon size="24" class="mr-2" color="#ffffff" :icon="mdiPhone" />
              <a
                :href="`tel:+1${getCustServNumWODash(locale)}`"
                class="font-weight-medium font-size--20 text-white"
                >{{ getCustServNumWDash(locale) }}</a
              >
            </p>
          </v-col>
        </v-row>
        <v-row v-else :class="{ 'text-center': $vuetify.display.xs }">
          <!-- <temp>---Agent Photo-----------------------------------------</temp> -->
          <v-col cols="12" sm="3" md="2" :mb-3="$vuetify.display.xs">
            <v-img
              alt="Rep photo"
              class="mx-auto rep-image"
              height="80px"
              max-width="80px"
              :src="displayPic || repFallbackImage"
            >
              <!-- Content to display if the main src fails to load -->
              <template v-slot:error>
                <v-img
                  class="mx-auto"
                  height="80px"
                  max-width="80px"
                  :src="repFallbackImage"
                ></v-img>
              </template>
            </v-img>
          </v-col>

          <!-- <temp>---Agent Info-----------------------------------------</temp> -->
          <v-col cols="12" sm="9" md="10">
            <v-row
              class="agent-block"
              :class="$vuetify.display.xs ? 'justify-center' : 'justify-left'"
            >
              <!-- Agent Name & Title -->
              <v-col cols="9" sm="6" md="4" lg="4" class="pl-0 pr-0">
                <h3
                  role="heading"
                  aria-level="2"
                  class="text-h3 font-weight-medium mb-2"
                  :class="$vuetify.display.xs ? 'text-center' : 'text-left'"
                >
                  {{ agent.name }}
                </h3>
                <h3
                  role="presentation"
                  v-if="
                    agent.isRvp &&
                    agent.addresses.filter(
                      (address: any) =>
                        address.type === 'home' &&
                        !(
                          address.state === 'NF' ||
                          address.state === 'PE' ||
                          address.state === 'NS' ||
                          address.state === 'NB' ||
                          address.state === 'PQ' ||
                          address.state === 'ON' ||
                          address.state === 'MB' ||
                          address.state === 'SK' ||
                          address.state === 'AB' ||
                          address.state === 'BC' ||
                          address.state === 'YT' ||
                          address.state === 'NT' ||
                          address.state === 'NU'
                        )
                    ).length > 0
                  "
                  class="text-h5 font-weight-medium mb-1 pb-1"
                  :class="{ 'text-center': $vuetify.display.xs }"
                >
                  {{ $t('L_' + agent.title) }}
                </h3>
              </v-col>
              <!-- Contact -->
              <v-col
                cols="9"
                sm="6"
                md="4"
                lg="4"
                :class="life ? '' : 'noPaddingTop'"
                class="pl-0 pr-0"
              >
                <v-row justify="center" :class="$vuetify.display.xs ? 'text-left' : 'text-left'">
                  <v-col cols="12 pl-0">
                    <h4
                      class="text-body-h4 font-weight-medium mb-3"
                      :class="$vuetify.display.xs ? 'text-center' : 'text-left'"
                    >
                      {{ $t('L_contact') }}
                    </h4>
                    <!-- * OFFICE PHONE * -->
                    <p
                      v-if="agent.office && agent.office.phone"
                      class="font-weight-medium mr-2 mb-3 blueLinkPointer"
                    >
                      <v-icon color="primary" :icon="mdiPhone" />
                      <a :href="'tel:+1' + agent.office.phone" class="ml-1 blueLinkPointer">{{
                        phoneFormat(agent.office.phone)
                      }}</a>
                    </p>
                    <!-- * CELL PHONE * -->
                    <p
                      v-if="agent.useCellPhone && agent.cell"
                      class="font-weight-medium mr-2 mb-3 blueLinkPointer"
                    >
                      <v-icon color="primary" :icon="mdiCellphone" />
                      <a :href="'tel:+1' + agent.cell" class="ml-1 blueLinkPointer">{{
                        phoneFormat(agent.cell)
                      }}</a>
                    </p>
                    <!-- * FAX * -->
                    <p
                      v-if="agent.office && agent.office.fax"
                      class="font-weight-medium mr-2 mb-3 blueLinkPointer"
                    >
                      <v-icon color="primary" :icon="mdiPrinter" />
                      <a :href="'tel:+1' + agent.office.fax" class="ml-1 blueLinkPointer">
                        {{ phoneFormat(agent.office.fax) }}
                      </a>
                    </p>
                    <!-- * EMAIL * -->
                    <p v-if="agent.email" class="font-weight-medium mr-2 mb-3">
                      <v-icon color="primary" :icon="mdiEmail" />
                      <a
                        href=""
                        @click.prevent="emailRep(agent.agentId)"
                        class="ml-1 blueLinkPointer"
                        >{{ $t('L_rep_email_me') }}</a
                      >
                    </p>
                    <!-- * APPOINTMENT URL * -->
                    <p v-if="agent.appointmentUrl" class="font-weight-medium mr-2 mb-3">
                      <v-icon color="primary" :icon="mdiCalendar" />
                      <a
                        href=""
                        @click.prevent="openCalendar(agent.appointmentUrl)"
                        class="ml-1 blueLinkPointer"
                        >{{ $t('L_make_an_appointment') }}</a
                      >
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <!-- My Office -->
              <v-col
                cols="9"
                sm="12"
                md="4"
                lg="4"
                :class="life ? '' : 'noPaddingTop'"
                class="pl-0 pr-0"
              >
                <v-row class="px-0 my-0" :class="{ 'mt-4': $vuetify.display.xs }">
                  <v-col cols="12" sm="12" class="pt-0 mt-0 pl-0 pr-0">
                    <MyRepAddressComponent
                      :rep="agent"
                      v-if="agents.length > 0 && agent.office !== undefined"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <ContactRep
        v-if="contactAgent"
        v-model="contactMe"
        :agents="[contactAgent]"
        @close="contactMe = false"
        @send-message="send($event)"
        close-selector="contact_your_rep_close"
        modal-class="contact_your_rep_modal"
        :sender="sender"
      />
      <MessageDialog
        :show-dialog="dialog"
        :has-button-two="true"
        :is-persistent="true"
        type="info"
        :title="$t('L_you_are_being_redirected_to_an_appointment_scheduling_website')"
        :message="$t('L_this_link_will_take_you_to_a_third_party_site_that_has_its_own')"
        :button-two-label="$t('L_go_back')"
        :button-one-label="$t('L_continue')"
        @buttonTwoAction="dialog = false"
        @buttonOneAction="closeAndGoToCalendar"
      />
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { openInNewWindow } from '@/mixins/openNewWindow';
import ContactRep from '../components/ContactRep/ContactRep.vue';
import MessageDialog from './MessageDialog.vue';
import { type ComponentOptions, defineComponent, type PropType } from 'vue';

import repFallbackImage from '@/assets/rep-thumb.svg';
import MyRepAddressComponent from '@/modules/myRep/components/MyRepAddressComponent.vue';
import { mapActions, mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mdiCellphone, mdiCalendar, mdiEmail, mdiPhone, mdiPrinter } from '@mdi/js';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import { OnexSelect } from '@primerica/onex-ui-lib';
import type { IGlobalStoreAgent } from '@/stores/global/globalStore.model.ts';

const componentOptions: ComponentOptions = {
  name: 'RepresentativeComponent',
  mixins: [openInNewWindow],
  props: {
    agents: {
      type: Array as PropType<IGlobalStoreAgent[]>,
      required: true,
    },
    restricted: {
      type: Boolean,
      required: false,
      default: false,
    },
    life: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ContactRep,
    MyRepAddressComponent,
    MessageDialog,
    OnexSelect,
  },
  data: () => ({
    dialog: false,
    contactMe: false,
    agent: {} as IGlobalStoreAgent,
    currentAgent: {},
    contactAgent: {},
    calendarLink: '',
    repFallbackImage,
    mapLinks: {
      iphone: 'maps://maps.google.com/?address=',
      android: 'http://maps.google.com/?daddr=',
      web: 'http://maps.google.com/?daddr=',
    },
    navigateTo: '',
    linkAddr: '',
    mdiCellphone,
    mdiCalendar,
    mdiEmail,
    mdiPhone,
    mdiPrinter,
  }),
  computed: {
    ...mapState(useCustomerStore, {
      getCustServNumWDash: 'getCustServNumWDash',
      getCustServNumWODash: 'getCustServNumWODash',
      customerProfile: 'customerProfile',
      investmentsSortedByDate: 'investmentsSortedByDate',
    }),
    ...mapState(usePolicyStore, ['policiesSortedByDate']),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      getAgent: 'getAgent',
    }),
    hasRvp() {
      return this.rvp?.name;
    },
    rvp() {
      return this.agent?.rvpId ? this.agent?.rvp : {};
    },
    title() {
      let header;
      if (this.hide) {
        header = this.$t('L_questions_about_policy');
      } else {
        header = this.agents?.length === 1 ? this.$t('L_your_rep') : this.$t('L_your_rep_account');
      }
      return header;
    },
    displayPic() {
      return this.agent?.displayPic ? this.agent?.displayPic : this.repFallbackImage;
    },
    office() {
      return this.agent?.office ? this.agent.office : {};
    },
    sender() {
      return {
        email: this.customerProfile?.email || '',
        phone: this.customerProfile?.mobilePhone || '',
        firstName: this.customerProfile.firstName,
        lastName: this.customerProfile.lastName,
      };
    },
    hide() {
      let agentExists = true;
      if (this.agents === undefined || this.agents === null) {
        agentExists = false;
      } else if (this.agents && this.agents.length > 0 && !this.agents[0]?.agentId) {
        agentExists = false;
      }
      return this.restricted || this.agent?.isHomeOfficeAgent || !agentExists;
    },
    reps() {
      const accounts: Array<{ product: string; agentId: string }> = [];
      this.policiesSortedByDate.forEach((pol: IPolicyStorePolicy) => {
        if (pol.contractId.length > 0) {
          accounts.push({
            product: `${this.$t('L_term_life_policy')} ${pol.contractId}`,
            agentId: pol.agentId,
          });
        }
      });
      this.investmentsSortedByDate.forEach(
        (acct: { accountNumber: string; productType: string; agentId: string }) => {
          if (acct.accountNumber.length > 0) {
            accounts.push({
              product: `${acct.productType} ${acct.accountNumber}`,
              agentId: acct.agentId,
            });
          }
        }
      );
      let reps: Array<{
        agentId: string;
        name: string;
        products?: string[];
        displayName?: string;
      }> = [];
      if (accounts.length > 0) {
        accounts.forEach((acct) => {
          const found = reps.find((a: { agentId: string }) => a.agentId === acct.agentId);
          if (!found) {
            const agent = this.getAgent(acct.agentId);
            if (agent?.agentId) {
              agent.products = [acct.product];
              agent.displayName = agent.name;
              reps.push(agent);
            }
          } else {
            reps = reps.map((rep) => {
              if (rep.agentId === acct.agentId) {
                rep.products?.push(acct.product);
              }
              return rep;
            });
          }
        });
      }
      return reps;
    },
  },
  mounted() {
    this.setAgent();
  },
  methods: {
    ...mapActions(useCustomerStore, ['contactRepresentative']),
    phoneFormat(number: string) {
      return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    setAddressToNavigate(office: {
      address1: string;
      address2?: string;
      city: string;
      state: string;
      zip: string;
    }) {
      const device = this.getUserAgent();
      const address2 = office.address2 ? ` ${office.address2}` : '';
      this.linkAddr = `${office.address1}${address2} ${office.city} ${office.state} ${office.zip}`;
      this.navigateTo =
        this.mapLinks?.[device] +
        this.linkAddr
          .toLowerCase()
          .replace(/ /g, '+')
          .replace(/,|-|_|\./g, '');
    },
    getUserAgent() {
      const uA = navigator.userAgent;
      if (uA.includes('iPhone') || uA.includes('iPad')) {
        return 'iphone';
      }
      if (uA.includes('Android')) {
        return 'android';
      }
      return 'web';
    },
    emailRep(agentId: string) {
      const agent = this.reps.find((a: { agentId: string }) => a.agentId === agentId);
      this.contactAgent = agent;
      this.contactMe = true;
    },
    openCalendar(calendarLink: string) {
      this.calendarLink = calendarLink;
      this.dialog = true;
    },
    send(emailPayload: object) {
      this.contactRepresentative(emailPayload);
    },
    setAgent() {
      if (this.agents?.length > 0) {
        this.agent = this.agents[0];
        this.currentAgent = this.agent?.index;
      }
      this.setAddressToNavigate(this.office);
    },
    async closeAndGoToCalendar() {
      this.dialog = false;
      await this.openInNewWindow({ url: this.calendarLink, target: '_blank' });
    },
  },
  watch: {
    currentAgent(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.agent = this.agents.find((a: IGlobalStoreAgent) => a.index === newVal);
      }
    },
    agents(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setAgent();
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.representative {
  background-color: #ffffff;

  .agent_card {
    color: #333333;
  }

  .rep-image {
    width: 80px;
    margin: 0 auto;
  }

  @media (max-width: 599px) {
    .wrap-at-xs {
      min-width: 100% !important;
    }
  }

  .width-100 {
    width: 100% !important;
  }

  .shift-right {
    margin-left: 114px;
  }

  .bgc-white {
    background: #333;
  }

  .close-dialog {
    font-size: 19px;
  }

  a {
    color: #02579e !important;
    font-weight: bold;

    &.map-link {
      padding-bottom: 3px;
    }
  }
}

.rep-wrapper-contacts {
  display: flex;

  @media only screen and (max-width: 760px) {
    flex-direction: column;
  }
}

.agent-block {
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
}

.blueLinkPointer {
  text-decoration: none;
  color: rgb(12, 109, 202);
  font-weight: 600;
  cursor: pointer;
}

.noPaddingTop {
  padding-top: 0px !important;
}
</style>
